<div class="wrapper">
    <p class="targe-date">
      Countdown to Start of Vote-Counting
      <!-- {{ months[month] + ' ' + day + ', ' + year }} -->
    </p>
    <div class="countdown">
      <div class="count-box">
        <div class="count-title">
          Days
        </div>
        <div class="count-number">
          {{days}}
        </div>
      </div>
      <div class="count-box">
        <div class="count-title">
          Hours
        </div>
        <div class="count-number">
          {{hours}}
        </div>
      </div>
      <div class="count-box">
        <div class="count-title">
          Minutes
        </div>
        <div class="count-number">
          {{minutes}}
        </div>
      </div>
      <div class="count-box">
        <div class="count-title">
          Seconds
        </div>
        <div class="count-number">
          {{seconds}}
        </div>
      </div>
    </div>
  </div>